export default __webpack_public_path__ + "static/media/deny-invitation.d297e9e3.svg";